
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "ar" : "en");
  };

  return (
    <Button 
      variant="ghost" 
      onClick={toggleLanguage}
      className="px-2 py-1 text-sm rounded-md transition-all hover:bg-palsustain-beige/30"
      aria-label={language === "en" ? "Switch to Arabic" : "Switch to English"}
    >
      <span className="font-medium">{language === "en" ? "العربية" : "English"}</span>
    </Button>
  );
};

export default LanguageSwitcher;
